import { Link } from "react-router-dom";
import styled from "styled-components";
import { tokens } from "../../public/tokens.js";

export const ModuleCards = styled.div`
  display: grid;
  gap: 20px;
  align-items: stretch;
`;

export const ModuleCard = styled(Link)`
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  min-height: 190px;
  padding: 10px;
  border-radius: ${tokens.globals["border-radius"]};
  border: 1px solid #d7dee8;
  background: ${tokens.colors.neutral.white};
  box-shadow: 0 2px 2.97px 0 rgba(125, 125, 125, 0.13);
`;

export const ModuleCardHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 12px 11px;
  border-radius: ${tokens.globals["border-radius"]};
  flex: 1 0 0;
  align-self: stretch;
  color: ${tokens.colors.neutral.white};
  overflow: hidden;
`;

export const HeaderBottom = styled.div`
  position: relative;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  z-index: 2;
`;

export const StatusRow = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 2;
  padding-top: 6px;
`;

export const StatusLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
`;

export const ChipBase = styled.span`
  display: flex;
  height: 18px;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: ${tokens.globals["border-radius"]};
  font-size: ${tokens.typography.fontSize["sm-10px"]};
  font-weight: ${tokens.typography.fontWeights.semibold};
`;

export const CodeIntake = styled.span`
  text-align: center;
  font-size: ${tokens.typography.fontSize["md-12px"]};
  font-weight: ${tokens.typography.fontWeights.regular};
  line-height: 12px;
`;

export const TitleRow = styled.h3`
  font-size: ${tokens.typography.fontSize["base-16px"]};
  font-weight: ${tokens.typography.fontWeights.bold};
  line-height: 20px;
  text-wrap: pretty;
  margin: 0;
`;

export const DateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  text-edge: cap;
  font-size: ${tokens.typography.fontSize["md-12px"]};
  font-weight: ${tokens.typography.fontWeights.regular};
  line-height: 12px;
  font-variant-numeric: ordinal;
  font-feature-settings: "ss05" on;
`;

export const MarkChip = styled.div`
  display: flex;
  min-height: 18px;
  max-height: 18px;
  padding: 4px;
  align-items: center;
  gap: 4px;
  border-radius: ${tokens.globals["border-radius"]};
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-size: ${tokens.typography.fontSize["sm-10px"]};
  font-weight: ${tokens.typography.fontWeights.bold};
  line-height: 100%;
`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 8px;
  width: 100%;
`;

export const ProgressWrapper = styled.div`
  width: 100%;
  margin-top: 6px;
`;

export const ProgressTrack = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 8px;
  background: ${tokens.colors.neutral.grey["200"]};
  border-radius: ${tokens.globals["border-radius"]};
  overflow: hidden;
`;

export const ProgressFillLearning = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: ${tokens.colors.brand["fresh-green"]["400"]};
`;

export const ProgressFillAssessment = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: ${tokens.colors.brand["fresh-green"]["700"]};
`;

export const ProgressFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 6px;
  width: 100%;
  color: ${tokens.colors.text.primary};
`;

export const TotalProgressText = styled.span`
  font-size: ${tokens.typography.fontSize["md-12px"]};
  font-weight: ${tokens.typography.fontWeights.medium};
`;

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: ${tokens.typography.fontSize["md-12px"]};
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
`;

export const SvgLayer = styled.div`
  position: absolute;
  right: -40px;
  bottom: -165px;
  width: 380.596px;
  height: 429.202px;
  opacity: 0.4;
  mix-blend-mode: soft-light;
  pointer-events: none;
  z-index: 0;
`;


export const FilterBar = styled.div`
  display: flex;
  height: 36px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: ${tokens.globals["border-radius"]};
  background: #06172a;
  width: fit-content;
  margin: 24px 0 20px 0;
`;

export const Pill = styled.button`
  color: ${tokens.colors.neutral.white};
  font-size: ${tokens.typography.fontSize["md-12px"]};
  font-weight: ${tokens.typography.fontWeights.semibold};
  line-height: 20px;
  letter-spacing: 0;
  padding: 4px 8px;
  border-radius: 8px;
  border: none;
  background: unset;
`;

export const ActivePill = styled(Pill)`
  background: rgba(248, 248, 252, 0.2);
`;

export const ProgramHead = styled.h1`
  color: #252423;
  font-size: ${tokens.typography.fontSize["3xl-24px"]};
  font-weight: ${tokens.typography.fontWeights.bold};
  line-height: ${tokens.typography.lineHeights["130"]};
  padding: 0 0 4px 0;
  margin: 0;
`;

export const ProgramInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${tokens.colors.ui.foreground};
  text-align: left;
  font-variant-numeric: ordinal;
  font-feature-settings: "ss05" on;
  font-size: ${tokens.typography.fontSize["md-12px"]};
  font-weight: ${tokens.typography.fontWeights.regular};
  line-height: 12px;
  flex-wrap: wrap;
`;
